/* sc-home-black — comportamento das seções da home dos temas Black (30/10/2026):
   carrossel de banners (sections/sc-home-banners.liquid) e vídeo do card "For the 1%."
   (sections/sc-home-dupla-video.liquid). Cada bloco é iniciado uma vez só (data-ok), então o
   arquivo pode ser carregado por mais de uma seção. */
(function () {
  var reduz = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- banners ---------- */
  var bans = document.querySelectorAll('[data-sch-ban]');
  for (var bi = 0; bi < bans.length; bi++) banner(bans[bi]);

  function banner(ban) {
    if (ban.getAttribute('data-ok')) return;
    ban.setAttribute('data-ok', '1');
    var track = ban.querySelector('[data-sch-track]');
    var todos = ban.querySelectorAll('[data-sch-slide]');
    var reais = ban.querySelectorAll('[data-sch-slide]:not([data-sch-clone])');
    var dots = ban.querySelectorAll('[data-sch-dot]');
    var n = reais.length;
    /* estilos com vizinhos aparecendo (vitrine, profundidade, claro): o último banner vem repetido
       no começo e o primeiro no fim; parado num repetido, pula para o original sem animação */
    var peek = ban.classList.contains('sch-ban--peek');

    /* barra da Black no rodapé só depois que o banner sai da tela (CSS em sc-home-black.css) */
    var html = document.documentElement;
    var rb = ban.getBoundingClientRect();
    if (rb.bottom > 0 && rb.top < window.innerHeight) html.classList.add('sch-ban-on');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { html.classList.toggle('sch-ban-on', e.isIntersecting); });
      }, { threshold: 0 }).observe(ban);
    }

    if (!track || n < 2) return;
    var atual = 0, el = reais[0], timer = null, parado = false, tEsp = null;
    var seg = parseInt(ban.getAttribute('data-auto'), 10) || 0;

    /* posição que deixa o slide s no meio (no estilo cheio, s.offsetLeft) */
    function posX(s) { return s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2; }
    function pular(s) {
      ban.classList.add('sem-anim');
      var sb = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = posX(s);
      track.style.scrollBehavior = sb;
      marcar(s);
      requestAnimationFrame(function () { requestAnimationFrame(function () { ban.classList.remove('sem-anim'); }); });
    }
    function irEl(s) {
      if (reduz) { pular(s); return; }
      track.scrollTo({ left: posX(s), behavior: 'smooth' });
      marcar(s);
    }
    function ir(i) {
      if (peek) {
        if (i >= n) { irEl(todos[todos.length - 1]); return; }
        if (i < 0) { irEl(todos[0]); return; }
      }
      irEl(reais[((i % n) + n) % n]);
    }
    function marcar(s) {
      el = s;
      atual = Number(s.getAttribute('data-i')) || 0;
      for (var k = 0; k < dots.length; k++) {
        var on = k === atual;
        dots[k].classList.toggle('is-on', on);
        dots[k].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var t = 0; t < todos.length; t++) {
        var vez = todos[t] === s;
        todos[t].classList.toggle('is-on', vez);
        if (vez) todos[t].removeAttribute('inert'); else todos[t].setAttribute('inert', '');
      }
    }
    function noMeio() {
      var c = track.scrollLeft + track.clientWidth / 2, melhor = el, d = Infinity;
      for (var t = 0; t < todos.length; t++) {
        var dd = Math.abs(todos[t].offsetLeft + todos[t].offsetWidth / 2 - c);
        if (dd < d) { d = dd; melhor = todos[t]; }
      }
      return melhor;
    }
    function parar() { parado = true; clearInterval(timer); }
    function rodar() {
      clearInterval(timer);
      if (!seg || reduz || parado) return;
      timer = setInterval(function () { if (!document.hidden) ir(atual + 1); }, seg * 1000);
    }

    track.addEventListener('scroll', function () {
      clearTimeout(tEsp);
      tEsp = setTimeout(function () {
        var s = noMeio();
        if (s.hasAttribute('data-sch-clone')) pular(reais[Number(s.getAttribute('data-i')) || 0]);
        else if (s !== el) marcar(s);
      }, 90);
    }, { passive: true });

    ban.addEventListener('click', function (e) {
      var d = e.target.closest('[data-sch-dot]');
      if (d) { parar(); ir(Number(d.getAttribute('data-sch-dot'))); return; }
      if (e.target.closest('[data-sch-next]')) { parar(); ir(atual + 1); return; }
      if (e.target.closest('[data-sch-prev]')) { parar(); ir(atual - 1); return; }
      /* clique num vizinho (fica inert, então o clique cai no trilho): vai para ele */
      if (peek && e.target === track) {
        var r = el.getBoundingClientRect();
        if (e.clientX < r.left) { parar(); ir(atual - 1); }
        else if (e.clientX > r.right) { parar(); ir(atual + 1); }
      }
    });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, parar, { passive: true });
    });
    ban.addEventListener('mouseenter', function () { clearInterval(timer); });
    ban.addEventListener('mouseleave', rodar);
    ban.addEventListener('focusin', function () { clearInterval(timer); });
    window.addEventListener('resize', function () { pular(el); });

    pular(reais[0]);
    rodar();
  }

  /* ---------- vídeo do card "For the 1%." ---------- */
  var boxes = document.querySelectorAll('[data-sch-video]');
  for (var vi = 0; vi < boxes.length; vi++) video(boxes[vi]);

  function video(box) {
    if (box.getAttribute('data-ok')) return;
    box.setAttribute('data-ok', '1');
    var v = box.querySelector('video');
    var b = box.querySelector('[data-sch-play]');
    if (!v) return;
    v.muted = true;
    var carregou = false, pausouNaMao = false;

    var reserva = v.getAttribute('data-src-x');
    function carregar() {
      if (carregou) return;
      carregou = true;
      var cel = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      v.src = (cel ? v.getAttribute('data-src-m') : v.getAttribute('data-src-d')) || v.getAttribute('data-src-d') || reserva;
    }
    /* 480p/720p montados pelo nome do arquivo: se não abrirem, volta para o original */
    v.addEventListener('error', function () {
      if (!reserva || v.getAttribute('src') === reserva) return;
      v.src = reserva;
      if (!pausouNaMao && !reduz) tocar();
    });
    function tocar() {
      carregar();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function estado() {
      var t = !v.paused;
      box.classList.toggle('is-tocando', t);
      if (b) b.setAttribute('aria-label', t ? 'Pausar vídeo' : 'Tocar vídeo');
    }
    v.addEventListener('play', estado);
    v.addEventListener('pause', estado);
    if (b) b.addEventListener('click', function () {
      if (v.paused) { pausouNaMao = false; tocar(); }
      else { pausouNaMao = true; v.pause(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!reduz && !pausouNaMao) tocar(); }
          else if (!v.paused) v.pause();
        });
      }, { threshold: 0.35 }).observe(box);
    }
  }
})();
